import { Button, ButtonProps } from '@collinsonx/design-system/core';
import useNavigation from 'hooks/useNavigation';
import colors from 'ui/colour-constants';

const backButtonStyles = {
  label: {
    color: 'var(--button-bg)',
  },
  root: {
    backgroundColor: colors.white,
    border: '1px solid var(--button-bg)',
  },
};

export default function BackButton(props: ButtonProps) {
  const { navigateToLounge } = useNavigation();

  return (
    <div style={{ padding: '0px', textAlign: 'left' }}>
      <Button
        onClick={() => navigateToLounge()}
        styles={backButtonStyles}
        {...props}
      />
    </div>
  );
}
